import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { SupportFormSubmission } from '../../entities';

export const submitSupportFormPending = createAction('support/SUBMIT_SUPPORT_FORM/pending');
export const submitSupportFormSucceed = createAction('support/SUBMIT_SUPPORT_FORM/succeed');
export const submitSupportFormFailed = createAction('support/SUBMIT_SUPPORT_FORM/failed');

export const submitSupportFormRequest =
  (data: SupportFormSubmission): AppThunk<Promise<void>> =>
  async (dispatch, _getState, context) => {
    const { supportFormService, loggingService } = context;

    try {
      dispatch(submitSupportFormPending());

      await supportFormService.submitSupportForm(data);

      dispatch(submitSupportFormSucceed());
    } catch (e) {
      const err = normalizeError(e);
      loggingService.error(err);

      dispatch(submitSupportFormFailed());
    }
  };
